module.exports = __webpack_public_path__ + "img/erc-20-default.839a0f0d.png";